var map = {
	"./Ellipse.svg": "3d89",
	"./RoundBottom.svg": "62a6",
	"./RoundBottomWhite.svg": "442b",
	"./active-challenge.svg": "7ee7",
	"./blue-v.svg": "41d6",
	"./blue-x.svg": "851d",
	"./burger.svg": "9958",
	"./burrito.svg": "f594",
	"./croissant.svg": "1336",
	"./donut.svg": "62cb",
	"./fries.svg": "c5e8",
	"./green-v.svg": "ffb7",
	"./heart-icon.svg": "abc8",
	"./iceCream.svg": "5739",
	"./pitta.svg": "67d0",
	"./pizza.svg": "f483",
	"./pretzel.svg": "f033",
	"./red-x.svg": "2120",
	"./riseup-badge.svg": "cad4",
	"./sandwich.svg": "820d",
	"./takeout.svg": "60cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8259";